exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-scoped-variables[data-v-2a543eed]{border:1px solid #9e9e9e;border-radius:.25rem;background:#fff}.fts-automation-scoped-variables .variable-header[data-v-2a543eed]{padding:.3rem .5rem;border-top-left-radius:inherit;border-top-right-radius:inherit;background:#eee}.fts-automation-scoped-variables .variable-item[data-v-2a543eed]{padding:.3rem .5rem 0}.fts-automation-scoped-variables .variable-item[data-v-2a543eed]:last-child{padding-bottom:.3rem}", ""]);

// exports
